export const APPLICATION_TYPES = [
  { name: 'Participates in ERAS' },
  { name: 'Participates in NRMP Match' },
  { name: 'Participates in San Francisco Match' },
  { name: 'Does NOT Participate In NRMP Match' },
  { name: 'Does NOT Participate In ERAS' },
  { name: 'Offers Preliminary Positions' },
  { name: 'COMLEX Required for Interview' },
  { name: 'USMLE Required for Interview' },
  { name: 'Only USMLE Required for Interview' },
  { name: 'Accepting Applications' }
];

export const PROGRAM_TYPES = [
  { name: 'University-Based' },
  { name: 'Community-Based' },
  { name: 'Community-Based/University Affiliated' },
  { name: 'Military-Based' },
  { name: 'Other' },
  { name: 'Osteopathic Recognition' }
];

export const SPECIAL_TRACKS = [
  { name: 'Required Research Rotation', value: 'Research Track' },
  { name: 'Rural Track', value: 'Rural' },
  { name: 'Hospitalist Track', value: 'Hospitalist' },
  { name: 'Primary Care Track', value: 'Primary Care' },
  { name: 'Women\'s Health Track', value: 'Women\'s Health' },
  { name: 'Academic or clinician educator', value: 'Educator' }
];

export const VISAS = [
  { name: 'H-1B' },
  { name: 'J-1' }
];

export const AVG_HOURS_MAX = 80;
export const PERCENT_MAX = 100;
export const SALARY_MIN = 0;
export const SALARY_MAX = 175000;
export const TOTAL_POSITIONS_MAX = 200;
export const TOTAL_FIRST_YEAR_POSITIONS_MAX = 80;
